/**
 * 作品类型 / 数字备案类型 等枚举
 */

/**
 * 数字备案证书编号前缀（与备案表同一查询链路）
 * SCSP-* 为平台通用前缀；其余为作品类型缩写前缀（如 MS20260831124032936655059）
 */
export const FILING_CERTIFICATE_PREFIXES = [
  'SCSP-CRCF',
  'SCSP-PDRC',
  'SCSP-CRCI',
  'SCSP-PDCC',
  'CPFB',
  'CZ',
  'MS',
  'MX',
  'QT',
  'SJT',
  'SP',
  'SY',
  'WZ',
  'YP'
]

/**
 * @param {string|null|undefined} keyword
 * @returns {boolean}
 */
export function isFilingCertificateNo(keyword) {
  const value = String(keyword || '').trim().toUpperCase()
  if (!value) return false
  // 长前缀优先，避免短码误伤（如 SP vs SJT 无交叉，但保持稳定匹配）
  const prefixes = [...FILING_CERTIFICATE_PREFIXES]
    .map((p) => String(p).toUpperCase())
    .sort((a, b) => b.length - a.length)
  return prefixes.some((p) => {
    if (!value.startsWith(p)) return false
    // SCSP-CRCF... / MS2026... / MS-xxx / 仅前缀本身
    if (p.startsWith('SCSP-')) return true
    const rest = value.slice(p.length)
    return rest === '' || rest.startsWith('-') || /^\d/.test(rest)
  })
}

/** 数字备案类型（与后端 proof_type / DigitalFilingType 一致）：0 原创、1 AIGC、2 产品发布存证 */
export const DIGITAL_FILING_TYPE = {
  ORIGINAL_DIGITAL_FILING: '0',
  AIGC_DIGITAL_FILING: '1',
  PRODUCT_RELEASE_FILING: '2'
}

/** 备案类型下拉、筛选用 */
export const DIGITAL_FILING_TYPE_LIST = [
  { label: '原创数字备案', value: DIGITAL_FILING_TYPE.ORIGINAL_DIGITAL_FILING },
  // { label: 'AIGC', value: DIGITAL_FILING_TYPE.AIGC_DIGITAL_FILING },
  { label: '产品发布存证', value: DIGITAL_FILING_TYPE.PRODUCT_RELEASE_FILING }
]

export const DIGITAL_FILING_TYPE_MAP = DIGITAL_FILING_TYPE_LIST.reduce((map, item) => {
  map[item.value] = item.label
  return map
}, {})

/**
 * @param {string|null|undefined} code
 * @returns {string}
 */
export function getDigitalFilingTypeLabel(code) {
  if (code == null) return '—'
  const c = String(code).trim()
  if (!c) return '—'
  return DIGITAL_FILING_TYPE_MAP[c] || c
}

/** 备案文件类型：0 图片、1 音频、2 视频、3 文档 */
export const FILING_FILE_TYPE = {
  IMAGE: "0",
  AUDIO: "1",
  VIDEO: "2",
  DOC: "3"
}

/**
 * 各备案文件类型下可选的作品类型 value 列表
 * 图片：美术、建筑、摄影、工程设计图/产品设计图、地图/示意图、模型、其他
 * 文本：文字、口述、音乐、戏剧、曲艺、舞蹈、杂技艺术、其他
 * 音频：录音制品、其他
 * 视频：视听作品、录像制品、其他
 */
export const FILING_FILE_TYPE_TO_WORK_TYPE = {
  [FILING_FILE_TYPE.IMAGE]: ['art', 'architecture', 'photography', 'design', 'map', 'model', 'compilation', 'other'],
  [FILING_FILE_TYPE.DOC]: ['literary', 'oral', 'music', 'drama', 'quyi', 'dance', 'acrobatic', 'compilation', 'other'],
  [FILING_FILE_TYPE.AUDIO]: ['recording', 'compilation', 'other'],
  [FILING_FILE_TYPE.VIDEO]: ['audiovisual', 'video', 'compilation', 'other']
}

// 用于下拉框、单选框等列表展示
export const WORK_TYPE_LIST = [
  { label: '摄影作品', value: 'photography' },
  { label: '建筑作品', value: 'architecture' },
  { label: '美术作品', value: 'art' },
  { label: '地图/示意图', value: 'map' },
  { label: '工程设计图/产品设计图', value: 'design' },
  { label: '模型作品', value: 'model' },
  { label: '文字作品', value: 'literary' },
  { label: '戏剧作品', value: 'drama' },
  { label: '曲艺作品', value: 'quyi' },
  { label: '录像制品', value: 'video' },
  { label: '视听作品', value: 'audiovisual' },
  { label: '口述作品', value: 'oral' },
  { label: '音乐作品', value: 'music' },
  { label: '舞蹈作品', value: 'dance' },
  { label: '汇编作品', value: 'compilation' },
  { label: '录音制品', value: 'recording' },
  { label: '杂技艺术作品', value: 'acrobatic' },
  { label: '符合作品特征的其他智力成果', value: 'other' },
];

// 用于通过 value 快速查找 label 的字典映射
export const WORK_TYPE_MAP = WORK_TYPE_LIST.reduce((map, item) => {
  map[item.value] = item.label;
  return map;
}, {});

/**
 * 根据英文 value 获取对应的中文描述
 * @param {string} value 
 * @returns {string} 
 */
export function getWorkTypeLabel(value) {
  return WORK_TYPE_MAP[value] || '无';
}
